/*
 * @Author       : yiyang
 * @Date         : 2020-12-24 16:18:32
 * @LastEditors  : yiyang
 * @LastEditTime : 2020-12-25 16:16:16
 * @PRD          : 
 * @Description  : 
 * @FilePath     : /work/yit_fe_shangbo/src/routes/course/components/KnowPanel.js
 * @URL          : 
 */
import './KnowPanel.css'
import React, { PureComponent, Fragment } from 'react'
import { getThemeColor } from 'utils/utils'
import NETImage from 'components/net-image'

export default class KnowPanel extends PureComponent {
    get themeColor() {
        const { theme } = this.props
        return getThemeColor(theme).default
    }

    get titleStyle() {
        return {
            color: this.themeColor,
            borderLeftColor: this.themeColor,
        }
    }

    renderIllustration = () => {
        const { ki } = this.props

        if (!ki) return null

        return (
            <Fragment>
                <div className='np-insert-title'>illustration/插图：</div>
                {
                    ki.map((item, i) => (
                        <div
                            key={i}
                            className='np-insert-line'
                            style={{ marginBottom: ki.length === i + 1 ? '.35rem' : '0' }}
                        >
                            {item}
                        </div>
                    ))
                }
            </Fragment>
        )
    }

    renderItem = (item, i) => {
        const [type, area, styles] = item
        if ("p" === type)
            return <p key={i} className='np-item-area'>{area}</p>
        else if ("img" === type)
            return (
                <NETImage
                    usePreview
                    useAutoHeight
                    key={i}
                    className='np-item-img'
                    // imgClassname='small-img'
                    prefix={this.props.theme}
                    src={area}
                    styles={styles}
                />
            )
        else if ("i" === type)
            return <div key={i} className='np-item-i'>{area}</div>
        else if ("pm" === type)
            return <div key={i} className='np-item-pm'>{area}</div>
        else if ("br" === type)
            return <br key={i} />
        else
            return null
    }

    renderSection = (item, i) => {
        const { knowledges } = this.props
        const { keywords, desription } = item

        return (
            <div key={i} className='np-item' style={{ marginBottom: knowledges.length === i + 1 ? '.2rem' : '0' }} >
                <div className='np-item-title' style={this.titleStyle}>{keywords}</div>
                {
                    desription.map(this.renderItem)
                }
            </div>
        )
    }

    render() {
        const { knowledges } = this.props

        return (
            <Fragment>
                {
                    knowledges.map(this.renderSection)
                }
                {
                    this.renderIllustration()
                }
            </Fragment>
        )
    }
}
